import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Card, CardTitle, Col, Row, Spinner } from 'reactstrap';
import * as app_consts from "../../../../../../../../constants/react_app_consts";
import { Button, Icon, RSelect } from '../../../../../../../../components/Component';
import TextInput from '../../../../../../../components/inputs/TextInput';
import { fail_unit_measurement_list, loading_unit_measurement_list, reset_unit_measurement_list, success_unit_measurement_list } from '../../../../../../../../reducers/dashboard_reducers/unit_measurement/unit_measurements_list_Slice';
import { FINALIZE_GRN_PROCESSING_ACCESS_DENIED_MSG, FINALIZE_GRN_PROCESSING_ERR_MSG, FINALIZE_GRN_PROCESSING_SUCCESS_MSG, RETRIEVE_UNIT_MEASUREMENTS_LIST_ACCESS_DENIED_MSG, RETRIEVE_UNIT_MEASUREMENTS_LIST_ERR_MSG, RETRIEVE_UNIT_MEASUREMENTS_LIST_SUCCESS_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_ACCESS_DENIED_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_ERR_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_SUCCESS_MSG } from '../../../../../../../../constants/success_error_messages_consts';
import { FINALIZE_GRN_PROCESSING_API, RETRIEVE_SPECIFC_BRANCH_STORAGE_LIST_BY_STATUS_ID_API, RETRIEVE_UNIT_MEASUREMENTS_BY_STATUS_ENDPOINT } from '../../../../../../../../api/api_data';
import { employee_dashboard_actions_helper } from '../../../../../../../../actions/actions_helper';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../../../../../../utils/Utils';
import { useDispatch } from 'react-redux';
import { fail_retrieve_warehouse_storages_list, loading_retrieve_warehouse_storages_list, reset_retrieve_warehouse_storages_list, success_retrieve_warehouse_storages_list } from '../../../../../../../../reducers/dashboard_reducers/warehouse/retrieve_warehouse_storages_list_Slice';
import ModalPreview from '../../../../../modal/modal_preview/ModalPreview';
import { fail_book_goods_to_inventory, loading_book_goods_to_inventory, reset_book_goods_to_inventory, success_book_goods_to_inventory } from '../../../../../../../../reducers/dashboard_reducers/warehouse/book_goods_to_inventory_Slice';
import { resolveWeighbridgeTicketPrefillData } from '../../../../../../../../utils/weighbridgeTicketNormalization';
import {
    formatWeighbridgeWeightInputMt,
    isGrnWeightSequenceValid,
    mapWeighbridgeWeightsToGrn,
    resolveGrnNetWeight,
} from '../../../../../../../../utils/weighbridgeUtils';

const initialState = {
    goods_received_id: "",
    goods_received_ref_number: "",
    branch_location_id: "",
    weighbridge_ticket_id: "",
    first_weight: "",
    second_weight: "",
    net_weight: "",
    weigh_bridge_ticket_number: "",
    weigh_bridge_ticket_reference_no: "",
    truck_driver_name: "",
    truck_licence_plate: "",
    transporter_name: "",
    total_mt_capacity: ""
};
const initialPreviewState = {
    goods_received_id: "",
    goods_received_ref_number: "",
    branch_location_id: "",
    weighbridge_ticket_id: "",
    first_weight: "",
    second_weight: "",
    net_weight: "",
    weigh_bridge_ticket_number: "",
    weigh_bridge_ticket_reference_no: "",
    truck_driver_name: "",
    truck_licence_plate: "",
    transporter_name: "",
    total_mt_capacity: ""
};

const syncPreviewState = (nextState) => ({
    ...nextState,
    total_mt_capacity: nextState?.total_mt_capacity || "",
});

const convertTicketPrefillWeightsToMt = (ticketPrefill = {}) => {
    const grnWeights = mapWeighbridgeWeightsToGrn(ticketPrefill);

    return {
        ...ticketPrefill,
        ...grnWeights,
        first_weight: formatWeighbridgeWeightInputMt(grnWeights.first_weight),
        second_weight: formatWeighbridgeWeightInputMt(grnWeights.second_weight),
        net_weight: formatWeighbridgeWeightInputMt(grnWeights.net_weight),
    };
};

const StorageDetailsStep = ({
    weighBridgeFormData,
    setWeighBridgeFormData,
    continue_processing_data,
    setContinueProcessingData,
    prevStep,
    nextStep,
    selectedWeighbridgeTicket,
}) => {

    const [errorVal, setErrorVal] = useState("");
    const [loading, setLoading] = useState(false);
    const [stepData, setStepData] = useState(initialState);
    const [preview_step_data, setPreviewStepData] = useState(initialPreviewState);
    const dispatch = useDispatch();
    const [refData, setRefData] = useState([]);
    const [openPreview, setOpenPreview] = useState(false);
    const selectedTicketPrefill = useMemo(
        () =>
            convertTicketPrefillWeightsToMt(
                resolveWeighbridgeTicketPrefillData(
                    weighBridgeFormData?.weighbridge_ticket_data || selectedWeighbridgeTicket,
                ),
            ),
        [selectedWeighbridgeTicket, weighBridgeFormData?.weighbridge_ticket_data],
    );

    useEffect(() => {
        setRefData(continue_processing_data);
        const totalCapacitySum = weighBridgeFormData.goods_received_products?.reduce((sum, item) => {
            // Convert total_capacity_in_mt to a number and add to the sum
            return sum + parseFloat(item?.total_capacity_in_mt);
        }, 0);
        const resolvedFirstWeight =
            weighBridgeFormData?.first_weight ||
            selectedTicketPrefill?.first_weight ||
            "";
        const resolvedSecondWeight =
            weighBridgeFormData?.second_weight ||
            selectedTicketPrefill?.second_weight ||
            "";
        const syncedStepData = {
            goods_received_id:
                continue_processing_data?.goods_received_id ||
                weighBridgeFormData?.goods_received_id ||
                "",
            goods_received_ref_number:
                continue_processing_data?.goods_received_ref_number ||
                weighBridgeFormData?.goods_received_ref_number ||
                "",
            branch_location_id:
                continue_processing_data?.branch_location_id ||
                weighBridgeFormData?.branch_location_id ||
                "",
            weighbridge_ticket_id:
                weighBridgeFormData?.weighbridge_ticket_id ||
                selectedTicketPrefill?.weighbridge_ticket_id ||
                continue_processing_data?.weighbridge_ticket_id ||
                continue_processing_data?.weigh_bridge_ticket_id ||
                "",
            first_weight: resolvedFirstWeight,
            second_weight: resolvedSecondWeight,
            net_weight: resolveGrnNetWeight(
                weighBridgeFormData?.net_weight ||
                    selectedTicketPrefill?.net_weight ||
                    continue_processing_data?.net_weight ||
                    "",
                resolvedFirstWeight,
                resolvedSecondWeight,
            ),
            weigh_bridge_ticket_number:
                weighBridgeFormData?.weigh_bridge_ticket_number ||
                selectedTicketPrefill?.weigh_bridge_ticket_number ||
                "",
            weigh_bridge_ticket_reference_no:
                weighBridgeFormData?.weigh_bridge_ticket_reference_no ||
                selectedTicketPrefill?.weigh_bridge_ticket_reference_no ||
                "",
            truck_driver_name:
                weighBridgeFormData?.truck_driver_name ||
                selectedTicketPrefill?.truck_driver_name ||
                "",
            truck_licence_plate:
                weighBridgeFormData?.truck_licence_plate ||
                selectedTicketPrefill?.truck_licence_plate ||
                "",
            transporter_name:
                weighBridgeFormData?.transporter_name ||
                selectedTicketPrefill?.transporter_name ||
                "",
            total_mt_capacity: totalCapacitySum || "",
        };
        setStepData(syncedStepData);
        setPreviewStepData(syncPreviewState(syncedStepData));

    }, [weighBridgeFormData, continue_processing_data, selectedTicketPrefill]);

    const handleOnblur = (e) => {
        const normalizedValue = e.target.value ? parseFloat(e.target.value).toFixed(2) : "";
        const nextState = {
            ...stepData,
            [e.target.name]: normalizedValue,
        };

        if (
            nextState.first_weight &&
            nextState.second_weight &&
            !isGrnWeightSequenceValid(
                nextState.first_weight,
                nextState.second_weight,
                nextState.net_weight,
            )
        )
        {
            setStepData({ ...nextState, [e.target.name]: "", ["net_weight"]: "" });
            setPreviewStepData(syncPreviewState({ ...nextState, [e.target.name]: "", ["net_weight"]: "" }));
            messageToast("First Weight (Gross) Cannot Be Less than Second Weight (Tare)", app_consts.FAIL);
            return;
        }

        const netWeight = resolveGrnNetWeight(
            nextState.net_weight,
            nextState.first_weight,
            nextState.second_weight,
        );

        const updatedState = { ...nextState, ["net_weight"]: netWeight };
        setStepData(updatedState);
        setPreviewStepData(syncPreviewState(updatedState));
    };

    // Handle Change
    const handleChange = (e) => {
        const updatedState = { ...stepData, [e.target.name]: e.target.value };
        setStepData(updatedState);
        setPreviewStepData(syncPreviewState(updatedState));
    };

    const previousStep = () => {
        setWeighBridgeFormData((prev) => ({ ...prev, ...stepData }));
        prevStep();
    };

    //Preview Details
    const handlePreview = () => {
        setErrorVal("");
        setWeighBridgeFormData((prev) => ({ ...prev, ...stepData }));
        setOpenPreview(true);
    };

    const handleSubmit = () => {
        setErrorVal("");
        setOpenPreview(false);
        const payload = {
            first_weight: stepData?.first_weight || "",
            second_weight: stepData?.second_weight || "",
            net_weight: stepData?.net_weight || "",
            goods_received_ref_number:
                stepData?.goods_received_ref_number ||
                refData?.goods_received_ref_number ||
                "",
        };
        setWeighBridgeFormData((prev) => ({ ...prev, ...stepData }));
        // Finalize GRN processing
        dispatch(
            employee_dashboard_actions_helper(
                loading_book_goods_to_inventory,
                success_book_goods_to_inventory,
                fail_book_goods_to_inventory,
                FINALIZE_GRN_PROCESSING_ERR_MSG,
                FINALIZE_GRN_PROCESSING_SUCCESS_MSG,
                app_consts.POST,
                FINALIZE_GRN_PROCESSING_API,
                payload,
                FINALIZE_GRN_PROCESSING_ACCESS_DENIED_MSG
            )
        );
    };
    // Listen to Booking State
    const book_goods_to_inventory = useSelector((state) => state.book_goods_to_inventory.book_goods_to_inventory);

    useEffect(() => {
        if (book_goods_to_inventory.status !== app_consts.IDLE)
        {
            if (book_goods_to_inventory.status === app_consts.LOADING)
            {
                setErrorVal("");
                setLoading(true);
            } else
            {
                setLoading(false);
                if (book_goods_to_inventory.status === app_consts.FAIL)
                {
                    setErrorVal(book_goods_to_inventory.message);
                    messageToast(book_goods_to_inventory.message, app_consts.FAIL);
                } else if (book_goods_to_inventory.status === app_consts.SUCCESS)
                {
                    setContinueProcessingData(book_goods_to_inventory.data);
                    messageToast(FINALIZE_GRN_PROCESSING_SUCCESS_MSG, app_consts.SUCCESS);
                    nextStep();
                }
                dispatch(reset_book_goods_to_inventory());
            }
        }
    }, [book_goods_to_inventory]);

    return (
        <>
            <Card className="card-inner">
                <CardTitle tag="h5">Finalizing GRN Details</CardTitle>
                <Col lg="12">
                    <div className="form-group">
                        {weighBridgeFormData.consigner_type_id === app_consts.UAG_CONSIGNER_TYPE ? (
                            <>
                                <div className="form-label-group">
                                    <label className="form-label text-soft">User Account ID :</label>
                                </div>
                                <div className="form-control-wrap">
                                    <label className="form-label text-primary">UAG</label>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="form-label-group">
                                    <label className="form-label text-soft">User Account ID :</label>
                                </div>
                                <div className="form-control-wrap">
                                    <label className="form-label text-primary">{weighBridgeFormData.user_account_label}</label>
                                </div>
                            </>
                        )}
                    </div>
                </Col>
                <hr />
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                    }}
                >
                    <Row className="g-4">
                        <div className="form-label-group">
                            <label className="form-label text-soft fs-22px">Finalizing Details</label>
                        </div>
                        <TextInput
                            parentClassName="mt-4"
                            colSize={6}
                            label="Gross Weight"
                            type="number"
                            id_val="first_weight"
                            value={stepData?.first_weight}
                            handleChange={handleChange}
                            name="first_weight"
                            onBlur={handleOnblur}
                            disabled={!!weighBridgeFormData?.weighbridge_locked}
                        />
                        <TextInput
                            parentClassName="mt-4"
                            colSize={6}
                            label="Tare Weight"
                            type="number"
                            id_val="second_weight"
                            value={stepData.second_weight}
                            handleChange={handleChange}
                            name="second_weight"
                            onBlur={handleOnblur}
                            disabled={!stepData.first_weight}
                        />
                        <TextInput
                            parentClassName="mt-4"
                            colSize={6}
                            label="Net Weight"
                            type="number"
                            id_val="net_weight"
                            disabled
                            value={preview_step_data?.net_weight}
                            handleChange={handleChange}
                            name="net_weight"
                            onBlur={handleOnblur}
                        />
                        <TextInput
                            parentClassName="mt-4"
                            colSize={6}
                            label="Total Products Weight (MT)"
                            type="number"
                            id_val="total_mt_capacity"
                            value={preview_step_data.total_mt_capacity ? parseFloat(preview_step_data.total_mt_capacity).toFixed(2) : ""}
                            name="total_mt_capacity"
                            disabled
                        />
                        <Col xl="12">
                            <div className="form-group">
                                <div className="form-control-wrap-flex-wrap justify-between items">
                                    <Button
                                        onClick={previousStep}
                                        className="btn btn-dim btn-outline-primary"
                                        size="md"
                                    >
                                        Go to Previous Step
                                    </Button>
                                    <Button
                                        onClick={handlePreview}
                                        disabled={
                                            loading
                                                ? loading
                                                : !(stepData.second_weight)
                                        }
                                        color="primary"
                                        size="md"
                                    >
                                        {loading ? <Spinner size="sm" color="light" /> : "Preview & Finalize GRN"}
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {errorVal && (
                        <div className="mt-4">
                            <Alert color="danger" className="alert-icon">
                                {" "}
                                <Icon name="alert-circle" />
                                {errorVal}{" "}
                            </Alert>
                        </div>
                    )}
                </form>
            </Card>
            {/* Modal For Previewing Before Create */}
            <ModalPreview
                openPreview={openPreview}
                setOpenPreview={setOpenPreview}
                modalTitle={`Finalize GRN`}
                modalDescription={`Please Confirm Goods Received Details and Select 'Finalize GRN' to Book Goods Received Into Storage.`}
                moduleButtonText="Finalize GRN"
                prevType={app_consts.BOOK_PHYSICAL_GOODS_RECEIVED_INTO_STORAGE}
                prevData={preview_step_data}
                buttonFunction={handleSubmit}
            />
        </>
    );
};

export default StorageDetailsStep;
